module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I owe a great deal of gratitude to the many quilters who supported me throughout this process—their combined friendship, inspiration, guidance, and creativity have helped me with the making of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my husband of 50-plus years, Fred: I can’t express in words how you have stood by me all these years. Obviously, without you I would not be where I am today.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my dear daughter, Lisa, who is always willing to collaborate on new designs: Thank you for your guidance in color and composition, and your most valuable help in creating the perfect graphics. Thanks also to my son-in-law, Brian, for sharing her with me, as she has spent hours and hours on this.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my son, Michael; his wife, Stacey; and my grandsons, Nate and Tim: Thanks for all the encouragement, support, and computer expertise. I love you all dearly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my dear friend Jean Hall: You are always there for me. Thank you for your friendship, knowledge, writing skills, and guidance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my lifelong friend Connie Barry, who gave me the courage and help to write quilting books: Thank you for always being willing to read a rough draft.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To my critique group, Fiber Visions: Without all your help, guidance, and friendship I would not be the fiber artist I am today.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Last, but certainly not least, to my friends Judy Sabourin and Carol Ayotte: I owe you two a world of gratitude for your friendship and willingness to take a chance on any new concept or idea. I would not have been able to pull this off without your support and creativity. Thank you so much for our weeks on Cape Cod, just brainstorming and creating.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5acbfb0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0